import { render, staticRenderFns } from "./FlashSalesHistory.vue?vue&type=template&id=6fe4ace6&"
import script from "./FlashSalesHistory.vue?vue&type=script&lang=js&"
export * from "./FlashSalesHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports